
// 我的企业
const InterDiary = {
  'InterDiary_接口日志': { cn: '接口日志', en: 'Interface log', kr: '' },
  'InterDiary_开始时间': { cn: '开始时间', en: 'Start time' },
  'InterDiary_结束时间': { cn: '结束时间', en: 'End time' },
  'InterDiary_方法名': { cn: '方法名', en: 'Method name' },
  'InterDiary_编号': { cn: '编号', en: 'No.' },
  'InterDiary_tips': { cn: '仅限查看最近90天的接口日志', en: 'Only view interface logs of the last 90 days' },
  'InterDiary_time_tips': { cn: '最多可查看最近90天的接口日志，请调整查询的时间区间', en: 'You can view the interface logs of the last 90 days at most. Please adjust the query time interval.' },

  // 新增页面
  'InterDiary_编辑企业': { cn: '编辑企业', en: 'Edit the enterprise' },
  'InterDiary_请求时间': { cn: '请求时间', en: 'Request time' },
  'InterDiary_应用名称': { cn: '应用名称', en: 'Application name' },
  'InterDiary_添加企业': { cn: '添加企业', en: 'Add enterprise' },
  'InterDiary_企业全称': { cn: '企业全称', en: 'Company Full Name' },
  'InterDiary_公司简介': { cn: '公司简介', en: 'Company Profile' },
  'InterDiary_请输入企业全称，最多50个字符': { cn: '请输入企业全称，最多50个字符', en: 'Enter the full name of the company, up to 50 characters' },
  'InterDiary_选填，请输入公司简介，最多200个字符': { cn: '选填，请输入公司简介，最多200个字符', en: 'Optional, enter the company profile, up to 200 characters' },
  'InterDiary_请输入企业全称': { cn: '请输入企业全称', en: 'Please enter the full name of the enterprise' },
  'InterDiary_参数详情': { cn: '参数详情', en: 'Parameter details' },
  'InterDiary_企业名称不支持数字请勿填写数字': { cn: '企业名称不支持数字，请勿填写数字', en: 'Enterprise name does not include numbers, do not fill in them' },
  'InterDiary_添加企业成功': { cn: '添加企业成功', en: 'Successfully added enterprise' },
  'InterDiary_编辑企业成功': { cn: '编辑企业成功', en: 'Edit enterprise success' }
}

// 角色管理
const rold = {
  'authority_rold_log': { cn: '操作日志', en: 'Operation Log' },
  'authority_rold_edit': { cn: '编辑', en: 'Edit' },
  'authority_rold_delete': { cn: '删除', en: 'Delete' },
  'authority_rold_all': { cn: '全部', en: 'All' },
  'authority_rold_creating': { cn: '创建角色前请先创建企业', en: 'Establish an enterprise before establishing a role' },
  'authority_rold_query': { cn: '请输入角色名称查询', en: 'Enter the role name to query' },
  'authority_rold_role_name': { cn: '角色名称', en: 'Role Name' },
  'authority_rold_user_count': { cn: '账号数量', en: 'Number of Accounts' },
  'authority_rold_create_name': { cn: '创建人', en: 'Founder' },
  'authority_rold_modification': { cn: '最后一次修改时间', en: 'Last Modification Time' },
  'authority_rold_administration': { cn: '管理', en: 'Management' },
  'authority_rold_confirm': { cn: '确认', en: 'confirm' },
  'authority_rold_undone': { cn: '是否确定删除该角色组，该操作无法撤销', en: 'Are you sure you want to delete the role group? This operation cannot be undone' },
  'authority_rold_success': { cn: '成功', en: 'success' },
  'authority_rold_deleted': { cn: '删除角色成功', en: 'The role was deleted successfully' },
  // 新增页面
  'authority_rold_management': { cn: '角色名称', en: 'Role management' },
  'authority_rold_permissions': { cn: '角色权限', en: 'Select permissions' },
  'authority_rold_rolename': { cn: '请输入角色名称', en: 'Enter the role name' },
  'authority_rold_user_center': { cn: '用户中心', en: 'User center' },
  'authority_rold_characters': { cn: '角色名称不能超过50个字符', en: 'The role name cannot exceed 50 characters' },
  'authority_rold_addeds': { cn: '新增角色成功', en: 'New role successfully added' },
  'authority_rold_edits': { cn: '编辑角色成功', en: 'Edit role succeeded' },
  'authority_rold_submit': { cn: '提交', en: 'Submit' },
  'authority_rold_alls': { cn: '全选', en: 'Select All' },
  'authority_rold_none': { cn: '全不选', en: 'None' },

  'authority_rold_button_permissions': { cn: '菜单按钮权限', en: 'Menu button permissions' },
  'authority_rold_button_authority': { cn: '业务数据权限', en: 'Business data authority' },
  'authority_rold_button_Settings': { cn: 'PDA权限设置', en: 'PDA permission Settings' },
  'authority_rold_administrator': { cn: '暂未部署该服务，请联系管理员或业务经理', en: 'The service has not been deployed yet, please contact your administrator or business manager' },
  'authority_rold_related': { cn: '订单相关', en: 'Order related' },
  'authority_rold_relevant': { cn: '仓配相关', en: 'Warehouse with relevant' },
  'authority_rold_data': { cn: '业务数据', en: 'Business data' },
  'authority_rold_report': { cn: '报表', en: 'The report' },
  // 操作日志
  'authority_rold_content': { cn: '选择操作内容', en: 'Select Content' },
  'authority_rold_querys': { cn: '输入操作人查询', en: 'Input Operator Query' },
  'authority_rold_start': { cn: '开始日期', en: 'Start Date' },
  'authority_rold_end': { cn: '结束日期', en: 'End Date' },
  'authority_rold_operation': { cn: '操作人', en: 'Operator' },
  'authority_rold_type': { cn: '操作类型', en: 'Operation Type' },
  'authority_rold_role': { cn: '角色', en: 'Role' },
  'authority_rold_conters': { cn: '操作内容', en: 'Content' },
  'authority_rold_time': { cn: '时间', en: 'Time' }

}

// 账号管理
const account = {
  'authority_account_added': { cn: '新增', en: 'Add' },
  'authority_account_import': { cn: '导入', en: 'Import' },
  'authority_account_log': { cn: '操作日志', en: 'Operation Log' },
  'authority_account_edit': { cn: '编辑', en: 'Edit' },
  'authority_account_opening': { cn: '开通', en: 'Opening' },
  'authority_account_permissions': { cn: '复制权限', en: 'Copy permissions' },
  'authority_account_services': { cn: 'ECCANG专属服务', en: 'ECCANG exclusive services' },
  'authority_account_yet': { cn: '您还没有子账号', en: 'You dont have a sub account yet' },
  'authority_account_binding': { cn: '1，绑定钉钉后可以获取到贵司在钉钉的组织架构，根据组织架构展示员工账号', en: '1. Once binding the pin, one can obtain the organizational structure of your company, and display the employee account in accordance with the organizational structure' },
  'authority_account_successfully': {
    cn: '1.1，新员工入职（该钉钉账号创建成功后），易仓科技将自动为您创建该员工的账号，公司管理员点击【开通】为员工设置密码后，该员工可使用账户密码登录易仓科技系统（注：此时只是开通了账号，该账号并无任何权限，需分配对应角色权限后该账号才能拥有对应权限）',
    en: "1.1 When a new employee is employed (after the pin account is successfully established), ECCANG automatically establishes the employee's account. After the company administrator clicks [open] to set the password for the employee, the employee can use the account password to log in the ECCANG system (Note: At this time, the account is just only opened but has no permission. The account can only possess the  permissions which once are assigned to its corresponding role.)"
  },
  'authority_account_automatically': {
    cn: '1.2，员工离职（钉钉账号退出贵司企业后），易仓科技将自动为您注销该员工的账号，该员工将无法使用您在易仓科技购买的任何服务，也无法登入',
    en: "1.2 If an employee leaves (after leaving your company with a pin account), ECCANG automatically cancels the employee's account, and the employee will not be able to use any of the services purchased and log in"
  },
  'authority_account_nail': { cn: '绑定钉钉', en: 'Binding nail' },
  'authority_account_without': { cn: '不绑定，直接创建子账号', en: 'Establish a sub-account directly without binding' },
  'authority_account_information': { cn: '新增账号前请先添加企业信息', en: 'Please add enterprise information before adding new account' },

  'authority_account_input': { cn: '请输入员工姓名查询', en: 'Enter the employee name to query' },
  'authority_account_roles': { cn: '选择角色', en: 'Select a Role' },
  'authority_account_select_status': { cn: '选择状态', en: 'Select Status' },
  'authority_account_select_content': { cn: '选择操作内容', en: 'Select Content' },
  'authority_account_management': { cn: '管理', en: 'Management' },
  'authority_account_status': { cn: '状态', en: 'Status' },
  'authority_account_time': { cn: '时间', en: 'Time' },
  'authority_account_organization': { cn: '选择组织', en: 'Select the organization' },
  'authority_account_manually': { cn: '是否确定手动新增子账号', en: 'Whether to add a sub-account manually ' },
  'authority_account_default': { cn: '手动新增的子账号不支持离职自动停用，若该员工离职，需手动停用才能冻结该账号，创建成功后将自动加入默认组。', en: 'The manually added sub account does not support automatic termination of resignation. If the employee resigns, the account can be frozen only by manually deactivating it. After the account is created successfully, it will be automatically added to the default group.' },
  'authority_account_processing': { cn: '系统历史同名、同邮箱、同手机的账号数据存在多条,请联系管理员处理', en: 'There are many account datas with the same name, mailbox and mobile phone in the history of the system. Contact the administrator for dealing with' },
  'authority_account_editing': { cn: '主账号不允许编辑权限', en: 'The main account does not allow to edit the permission' },
  'authority_account_disabled': { cn: '账号已被停用', en: 'Account has been disabled' },
  'authority_account_Successful': { cn: '开通成功', en: 'Successful opening' },
  'authority_account_off': { cn: '开', en: 'OFF' },
  'authority_account_no': { cn: '关', en: 'NO' },
  'authority_account_succeededs': { cn: '复制成功', en: 'Copy succeeded' },
  'authority_account_default_group': { cn: '默认组', en: 'Default group' },
  'authority_account_name': { cn: '用户名', en: 'User name' },
  'authority_account_Operator': { cn: '操作人', en: 'Operator' },
  'authority_account_login_time': { cn: '最后一次登录时间', en: 'Last login time' },
  // 按钮
  'authority_account_whole': { cn: '全部', en: 'whole' },
  'authority_account_enable': { cn: '启用', en: 'Enable' },
  'authority_account_disable': { cn: '禁用', en: 'Disable' },
  'authority_account_SYNC_ADD': { cn: '同步新增', en: 'Sync add' },
  'authority_account_SYNC_UPDATE': { cn: '同步更新', en: 'Sync update' },

  // 新增页面
  'authority_account_informa': { cn: '账号信息', en: 'Account Information' },
  'authority_account_phone': { cn: '手机号', en: 'phone' },
  'authority_account_OperatedPerson': { cn: '被操作人', en: 'Operated  person' },
  'authority_account_email': { cn: '邮箱地址', en: 'email' },
  'authority_account_password': { cn: '密码', en: 'password' },
  'authority_account_itself': {
    cn: '若该账号之前已经注册过系统，密码将以该账号自主设置的密码为准',
    en: 'If the account has been registered before, the password will be subject to the one set by the account itself'
  },
  'authority_account_enterprose': { cn: '企业信息', en: 'Corporate Information' },
  'authority_account_tips': { cn: '提示', en: 'Tips' },
  'authority_account_duplicated': { cn: '用户代码和姓名是当前企业下的唯一值，不能重复', en: 'Code and name are the sole value of the current enterprise and cannot be repeated' },
  'authority_account_codes': { cn: '用户代码', en: 'User Code' },
  'authority_account_allowed': {
    cn: '只允许字母,数字,下划线,中划线,@,英文的点',
    en: 'Only letters, numbers, underscores, middle dashes, @, dots in English permitted'
  },
  'authority_account_structure': { cn: '组织架构', en: 'Organizational structure' },
  'authority_account_full': { cn: '姓名', en: 'Full name' },
  'authority_account_OperationType': { cn: '操作类型', en: 'Operation  type' },
  'authority_account_full_of_en': { cn: '英文姓名', en: 'English name' },
  'authority_account_characters': { cn: '最多50个字符', en: 'Up to 50 characters' },
  'authority_account_supported': { cn: '当前账号为主账号，默认拥有所有权限，不支持编辑', en: 'The current account is the main account and owns all permissions by default. Editing is prohibited.' },
  'authority_account_group': { cn: '角色组', en: 'Role Group' },
  'authority_account_create': { cn: '去创建角色', en: 'To create characters' },
  'authority_account_belongs': { cn: '新增账号前需先创建该账号所属的角色', en: 'Before adding an account, it should establish its role' },
  'authority_account_stores': { cn: '绑定仓库和店铺', en: 'Bind warehouse and shop' },
  'authority_account_loading': { cn: '仓库和店铺加载中...', en: 'Warehouse and store loading...' },
  'authority_account_bindings': { cn: '绑定', en: 'binding' },
  'authority_account_available': { cn: '暂无数据', en: 'No data available' },
  'authority_account_submit': { cn: '提交', en: 'Submit' },
  'authority_account_number': { cn: '请输入手机号', en: 'Please enter your mobile phone number' },
  'authority_account_format': { cn: '手机号码格式不正确', en: 'Incorrect mobile phone number format' },
  'authority_account_emails': { cn: '请输入您的邮箱', en: 'Please enter your email' },
  'authority_account_wrong': { cn: '邮箱格式有误哦', en: 'Email format is wrong' },
  'authority_account_four_verCode': { cn: '请输入4位图形验证码', en: 'Please enter a 4-digit graphic verification code' },
  'authority_account_passwords': { cn: '请输入密码', en: 'Please input a password' },
  'authority_请输入': { cn: '请输入', en: 'Please enter' },
  'authority_account_请输入账号名': { cn: '请输入账号名', en: 'Please enter your name' },
  'authority_account_passwords_no': { cn: '两次密码不一致', en: "Two passwords don't match" },
  'authority_account_Agreement': { cn: '请勾选用户协议', en: 'Please check the User Agreement' },
  'authority_account_请勾选权限分配': { cn: '请勾选权限分配', en: 'Please check permission assignment' },
  'authority_account_combination': { cn: '请输入8至16位字母大小写加数字组合密码', en: 'Please enter 8 to 16 letters, case and number combination password' },
  'authority_account_cannot': { cn: '代码不能为空', en: 'Code cannot be empty' },
  'authority_account_groups': { cn: '请选择角色组', en: 'Please select role group' },

  'authority_account_order': { cn: '订单管理系统', en: 'Order management system' },
  'authority_account_customer': { cn: '客服店铺', en: 'Customer service shop' },
  'authority_account_operator_shop': { cn: '操作员店铺', en: 'Operator shop' },
  'authority_account_fuzzy': { cn: '输入店铺名称模糊搜索', en: 'Enter store name and dark search' },
  'authority_account_system': { cn: '仓配管理系统', en: 'Management system of warehouse and distribution ' },
  'authority_account_shop': { cn: '绑定客服店铺', en: 'Binding of the customer service shop' },
  'authority_account_warehouse': { cn: '仓库', en: 'Warehouse' },
  'authority_account_search': { cn: '输入仓库名称模糊搜索', en: 'Enter warehouse name and dark search' },
  'authority_account_amazon_search': { cn: 'Amazon运营系统', en: 'Amazon Operating System' },
  'authority_account_store': { cn: '店铺', en: 'The store' },
  'authority_account_published': { cn: '刊登', en: 'Published' },
  'authority_account_library': { cn: '产品库', en: 'Product library' },
  'authority_account_supporteds': { cn: '只支持中英文，下划线，中横线，阿拉伯数字，和@', en: 'Only support Chinese and English, underlines, middle horizontal lines, Arabic numerals, and @' },
  'authority_account_exceeds': { cn: '字符长度不能超过50', en: 'The length of the character cannot exceed 50' },
  'authority_account_dots': { cn: '用户代码只允许字母,数字,下划线,中划线,@,英文的点', en: 'User code allows only alphabetic, numeric, underscore, underscore,@, and English dots' }
}

export default {
  ...InterDiary,
  ...rold,
  ...account
}
